import { UserAgentContext } from 'features/user-agent/userAgent';
import { useContext } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

export const useSocialElementsDisabled = (): boolean => {
  // Commendted out for now while we decide how to handle
  // Social elements within the white labels apps
  // const { isListenerAppWebview } = useContext(UserAgentContext);
  // const channel = useAppSelector((state) => state.channel.channelDetails);

  // return isListenerAppWebview && !!channel?.networkAvailable;
  return false;
};

export const useBypassAccessCodeNetwork = (): boolean => {
  const { isListenerAppWebview } = useContext(UserAgentContext);
  const { pathname } = useLocation();
  const isNetworkPath = matchPath('/network', pathname);

  return isListenerAppWebview && !!isNetworkPath;
};
